
import { motion } from 'framer-motion';

const WhyChooseUs = () => {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Secure & Insured',
      description: 'Every shipment is fully insured with end-to-end security protocols and real-time monitoring.',
      color: 'bg-primary-blue',
    },
    {
      icon: 'ri-time-line',
      title: 'On-Time Guarantee',
      description: '99.2% on-time delivery rate backed by our commitment to punctuality and reliability.',
      color: 'bg-primary-green',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Round-the-clock customer service in multiple languages across all time zones.',
      color: 'bg-primary-blue',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparent Pricing',
      description: 'No hidden fees. Clear, competitive rates with detailed cost breakdowns upfront.',
      color: 'bg-primary-green',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Options',
      description: 'Carbon-neutral shipping options and sustainable logistics solutions available.',
      color: 'bg-primary-blue',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Digital Documentation',
      description: 'Paperless processes with instant access to all shipping documents online.',
      color: 'bg-primary-green',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block px-4 py-2 bg-primary-blue/10 rounded-lg text-sm font-semibold text-primary-blue uppercase tracking-wider mb-4 whitespace-nowrap">
              Why TrackVerse
            </div>
            <h2 className="font-heading text-4xl lg:text-5xl text-gray-900 font-bold mb-6">
              The Smart Choice for Global Logistics
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Since 2020, we have been redefining logistics excellence. Founded by Michael Ashley with a vision to simplify global trade, TrackVerse has grown to serve businesses across 50+ countries.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="text-center p-4 bg-gray-50 rounded-xl">
                <div className="text-3xl font-bold text-primary-blue mb-1">2020</div>
                <div className="text-sm text-gray-600">Founded</div>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-xl">
                <div className="text-3xl font-bold text-primary-green mb-1">500+</div>
                <div className="text-sm text-gray-600">Team Members</div>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="https://public.readdy.ai/ai/img_res/fd49df2146fbfb6962ab98bbe066c544.jpg"
                alt="Michael Ashley - Founder"
                className="w-16 h-16 rounded-full object-cover border-2 border-primary-green"
              />
              <div>
                <div className="font-semibold text-gray-900">Michael Ashley</div>
                <div className="text-sm text-gray-500">Founder & CEO</div>
              </div>
            </div>
          </motion.div>

          {/* Right Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow group"
              >
                <div className={`w-12 h-12 flex items-center justify-center ${feature.color} rounded-xl mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${feature.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
